// WARNING: Don't make changes here! The content of this file is generated by: 
// App\Command\CreateUserEventSourceMessageTypesJsFileCommand::execute

export const PUSH_NOTIFICATION_RECEIVED = 'PUSH_NOTIFICATION_RECEIVED';
export const USER_PLAYBACK_SYNCED = 'USER_PLAYBACK_SYNCED';
export const PAUSE_TRACK = 'PAUSE_TRACK';
export const PLAY_TRACK = 'PLAY_TRACK';
export const SEEK_TRACK = 'SEEK_TRACK';
export const PLAY_NEXT_TRACK = 'PLAY_NEXT_TRACK';
export const PLAY_PREVIOUS_TRACK = 'PLAY_PREVIOUS_TRACK';
export const SET_CURRENT_TIME = 'SET_CURRENT_TIME';
export const PLAYLIST_CREATED = 'PLAYLIST_CREATED';
export const PLAYLIST_DELETED = 'PLAYLIST_DELETED';
export const PLAYLIST_RENAMED = 'PLAYLIST_RENAMED';
export const UPLOAD_FINISHED_TRACK_CREATED = 'UPLOAD_FINISHED_TRACK_CREATED';
export const SEGMENT_EXPORTED_TRACK_CREATED = 'SEGMENT_EXPORTED_TRACK_CREATED';
export const TRACK_DUPLICATED = 'TRACK_DUPLICATED';
export const TRACKS_DUPLICATED = 'TRACKS_DUPLICATED';
export const TRACK_DUPLICATED_TO_OTHER_PLAYLIST = 'TRACK_DUPLICATED_TO_OTHER_PLAYLIST';
export const TRACKS_DUPLICATED_TO_OTHER_PLAYLIST = 'TRACKS_DUPLICATED_TO_OTHER_PLAYLIST';
export const TRACK_DELETED = 'TRACK_DELETED';
export const TRACKS_DELETED = 'TRACKS_DELETED';
export const TRACK_UPLOAD_FINISHED = 'TRACK_UPLOAD_FINISHED';
export const TRACKS_UPLOAD_FINISHED = 'TRACKS_UPLOAD_FINISHED';
export const TRACK_NAME_CHANGED = 'TRACK_NAME_CHANGED';
export const TRACK_INFO_CHANGED = 'TRACK_INFO_CHANGED';
export const WAVEFORM_CREATED = 'WAVEFORM_CREATED';
export const DOWNLOAD_FROM_DRIVE = 'DOWNLOAD_FROM_DRIVE';
export const DOWNLOAD_TRACKS_CREATE_ZIP = 'DOWNLOAD_TRACKS_CREATE_ZIP';
export const GENERATE_PEAKS_PROGRESS = 'GENERATE_PEAKS_PROGRESS';
export const EXPORT_TRACK_PROGRESS = 'EXPORT_TRACK_PROGRESS';
export const SEGMENT_CREATED = 'SEGMENT_CREATED';
export const SEGMENT_CREATE = 'SEGMENT_CREATE';
export const SEGMENT_UPDATE = 'SEGMENT_UPDATE';
export const SEGMENT_DELETE = 'SEGMENT_DELETE';
export const SEGMENT_AUDIO_CROP = 'SEGMENT_AUDIO_CROP';
export const SEGMENT_AUDIO_DELETE = 'SEGMENT_AUDIO_DELETE';
export const POINT_CREATE = 'POINT_CREATE';
export const SEGMENT_CONVERSATION_USER_MENTIONED = 'SEGMENT_CONVERSATION_USER_MENTIONED';
export const SHARED_TRACK_SHOW_NOTIFICATION = 'SHARED_TRACK_SHOW_NOTIFICATION';
export const POINT_CONVERSATION_USER_MENTIONED_SHOW_NOTIFICATION = 'POINT_CONVERSATION_USER_MENTIONED_SHOW_NOTIFICATION';
export const POINT_CONVERSATION_USER_MENTIONED_SHOW_SNACKBAR = 'POINT_CONVERSATION_USER_MENTIONED_SHOW_SNACKBAR';
export const SEGMENT_CONVERSATION_USER_MENTIONED_SHOW_NOTIFICATION = 'SEGMENT_CONVERSATION_USER_MENTIONED_SHOW_NOTIFICATION';
export const SEGMENT_CONVERSATION_USER_MENTIONED_SHOW_SNACKBAR = 'SEGMENT_CONVERSATION_USER_MENTIONED_SHOW_SNACKBAR';
export const SEGMENT_CONVERSATION_ITEM_DELETED = 'SEGMENT_CONVERSATION_ITEM_DELETED';
export const SEGMENT_CONVERSATION_UPDATED = 'SEGMENT_CONVERSATION_UPDATED';
export const POINT_CONVERSATION_ITEM_DELETED = 'POINT_CONVERSATION_ITEM_DELETED';
export const POINT_CONVERSATION_UPDATED = 'POINT_CONVERSATION_UPDATED';
export const POINT_UPDATE = 'POINT_UPDATE';
export const POINT_DELETE = 'POINT_DELETE';
export const TRACK_SOURCE_CHANGED = 'TRACK_SOURCE_CHANGED';
export const TRACK_PLAYLIST_CHANGED = 'TRACK_PLAYLIST_CHANGED';
export const TRACKS_PLAYLIST_CHANGED = 'TRACKS_PLAYLIST_CHANGED';
export const PLAYLIST_PARENT_CHANGED = 'PLAYLIST_PARENT_CHANGED';
export const WAVEFORM_SOURCE_CHANGED = 'WAVEFORM_SOURCE_CHANGED';
export const DOWNLOAD_TRACK = 'DOWNLOAD_TRACK';
export const DOWNLOAD_TRACKS = 'DOWNLOAD_TRACKS';
export const DOWNLOAD_TRACKS_STATE = 'DOWNLOAD_TRACKS_STATE';
export const USER_EVENT_PLAYING_TRACK = 'USER_EVENT_PLAYING_TRACK';
export const USER_EVENT_SHARED_TRACK = 'USER_EVENT_SHARED_TRACK';
export const USER_EVENT_SHARED_SEGMENT = 'USER_EVENT_SHARED_SEGMENT';
export const MOVE_EXPLORER_ITEM = 'MOVE_EXPLORER_ITEM';
export const MOVE_EXPLORER_ITEMS = 'MOVE_EXPLORER_ITEMS';
export const BAND_WORKSPACE_USER_ADDED = 'BAND_WORKSPACE_USER_ADDED';
